import { Switch, Route } from "react-router-dom";
import { ListPageExamSchedule } from "./routes/List";
import { CreateExamSchedule } from "./routes/Create-exam";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { useLazyQuery } from "@apollo/client";
import {
  GET_CLASSES_LIST,
  GET_COURSES_LIST,
  GET_EXAM_TYPES,
} from "utils/graphql/services/exam-schedule/queries";
import myClassroomClient from "utils/graphql/myclassroom";
import { isEmpty } from "utils/helpers";
import { UpdateExamSchedule } from "./routes/update";
import AddSyllabusForm from "./routes/Upload-syllabus";
import SchDelivery from "./routes/deliverys";
import CreateDeliveryForm from "./routes/deliverys/create";
import updateDelivery from "./routes/deliverys/update-delivery";

interface IMatch {
  url: string;
}

export function ExamScheduleMyClassPage({ match }: { match: IMatch }) {
  const [showLoading, setShowIsLoading] = useState(true);
  const dispatch = useAppDispatch();

  const [getExamTypes, { loading, error, data }] = useLazyQuery(
    GET_EXAM_TYPES,
    {
      client: myClassroomClient,
      fetchPolicy: "no-cache",
    }
  );
  const [getClassesList, { loading: loadingCls, error: errorCls, data: dataCls }] = useLazyQuery(
    GET_CLASSES_LIST,
    {
      client: myClassroomClient,
      fetchPolicy: "no-cache",
    }
  );

  const { isLoading, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );
  const updateMetaDataMulti = (listData, metaKey, listData2, metaKey2) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    metadataList[metaKey2] = listData2;
    dispatch(metadataSuccess(metadataList));
    setShowIsLoading(false);
  };
  const updateMetaData = (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    dispatch(metadataSuccess(metadataList));
    setShowIsLoading(false);
  };

  const modifyCourseNames = (data) => {
    return data.map((item) => ({
      ...item,
      name: `${item.type}-${item.name}`,
    }));
  };

  useEffect(() => {
    (async () => {
      const [call1, call2] = await Promise.all([
        getExamTypes({ variables: {} }).catch(() => null),
        getClassesList({ variables: {} }).catch(() => null),
      ]);
      const examTypes = call1?.data?.getExamTypes || [];
      let classesList = call2?.data?.getClassesList || [];

      updateMetaDataMulti(
        examTypes,
        "exam_type_gq",
         classesList,"class_list_schdule"
      );

      setShowIsLoading(false);
    })();
  }, []);

  if (showLoading) {
    return <p>Loading metadata....</p>;
  }

  return (
    <>
      <Switch>
        <Route
          exact
          path={`${match.url}/list`}
          component={ListPageExamSchedule}
        />
        <Route
          exact
          path={`${match.url}/create_exam`}
          component={CreateExamSchedule}
        />
        <Route
          exact
          path={`${match.url}/update_exam/:schdule_id`}
          component={UpdateExamSchedule}
        />
        <Route
          exact
          path={`${match.url}/add_syllabus/:schdule_id`}
          component={AddSyllabusForm}
        />
        <Route
          exact
          path={`${match.url}/delivery_list/:schdule_id`}
          component={SchDelivery}
        />
        <Route
          exact
          path={`${match.url}/delivery/create/:schdule_id`}
          component={CreateDeliveryForm}
        />
        <Route
          exact
          path={`${match.url}/delivery/update/:schdule_id/:deliveryId`}
          component={updateDelivery}
        />
      </Switch>
    </>
  );
}
